import {Gender} from './gender';
import {UserMetadata} from './user-metadata';

export class ContactUserCard {
  userId: number;
  customerId: number;
  sourceId: number;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  dialogCount: number;
  userMiddleName: string;
  userZip: string;
  userState: string;
  userCity: string;
  userAddress: string;
  userGender: Gender;
  userDob: Date;
  userPhone: string;
  userMetadata: string;
  userAllowSms: boolean;
}
